module.exports = __webpack_public_path__ + "img/success.c79925a4.png";